import { render, staticRenderFns } from "./EdViewer.vue?vue&type=template&id=2141a350&scoped=true&"
import script from "./EdViewer.vue?vue&type=script&lang=js&"
export * from "./EdViewer.vue?vue&type=script&lang=js&"
import style0 from "./EdViewer.vue?vue&type=style&index=0&id=2141a350&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2141a350",
  null
  
)

export default component.exports